<div class="text-right mb-1">
  <button pButton [label]="'Create Setting'" (click)="createSetting()"></button>
</div>

<p-table
  #dataTable4
  [value]="settingList"
  [rows]="10"
  [lazy]="false"
  selectionMode="single"
  [(selection)]="selectedSetting"
  [responsive]="true"
  [paginator]="true"
  rowHover="true"
  resizableColumns="true"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>TaskType</th>
      <th>Sequence</th>
      <th>Next Sequence</th>
      <th>Send Alerts</th>
      <th>Add To Directed</th>
      <th>Enabled</th>
      <th>Action</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item>
    <tr (dblclick)="editSetting()">
      <td>{{ item?.settingName }}</td>
      <td>
        <span *ngIf="jobTaskTypeLookup?.length > 0">
          <span *ngFor="let x of item?.jobTaskTypeList" style="font-size: 12px">
            {{ jobTaskTypeLookup[x] }}<br />
          </span>
        </span>
      </td>
      <td>{{ item?.sequence }}</td>
      <td>
        <span *ngIf="item?.hoursUntilNextSequence > 0">
          in {{ item?.hoursUntilNextSequence }} hours
        </span>
      </td>
      <td>
        <span *ngIf="item.sendAlerts"><i class="fa fa-check"></i></span>
        <span *ngIf="!item.sendAlerts"><i class="fa fa-times"></i></span>
      </td>
      <td>
        <span *ngIf="item.addToDirected"><i class="fa fa-check"></i></span>
        <span *ngIf="!item.addToDirected"><i class="fa fa-times"></i></span>
      </td>
      <td>
        <p-inputSwitch
          [(ngModel)]="item.enabled"
          (onChange)="enabledSwitchChanged($event, item)"
        ></p-inputSwitch>
      </td>
      <td>
        <button
          pButton
          (click)="selectedSetting = item; editSetting()"
          icon="fa ui-icon-mode-edit"
          label="Edit"
        ></button>
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- DATATABLES DEPRECATED

<p-dataTabl #dataTable4 [value]="settingList" [rows]=10 [lazy]="false"
             selectionMode="single"
             [(selection)]="selectedSetting"
             (onRowDblclick)="editSetting()"
             [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true">

  <p-column header="Name" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">{{ item?.settingName }}</ng-template>
  </p-column>

  <p-column header="TaskType" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">
      <span *ngIf="jobTaskTypeLookup?.length > 0">
      <span *ngFor="let x of item?.jobTaskTypeList" style="font-size: 12px;">
        {{ jobTaskTypeLookup[x] }}<br />
      </span>
      </span>
    </ng-template>
  </p-column>

  <p-column header="Sequence" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">
      {{ item?.sequence }}
    </ng-template>
  </p-column>

  <p-column header="Next Sequence" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">
      <span *ngIf="item?.hoursUntilNextSequence > 0">
        in {{ item?.hoursUntilNextSequence }} hours
      </span>
    </ng-template>
  </p-column>

  <p-column header="Send Alerts" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">
      <span *ngIf="item.sendAlerts"><i class="fa fa-check"></i></span>
      <span *ngIf="!item.sendAlerts"><i class="fa fa-times"></i></span>
    </ng-template>
  </p-column>

  <p-column header="Add To Directed" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">
      <span *ngIf="item.addToDirected"><i class="fa fa-check"></i></span>
      <span *ngIf="!item.addToDirected"><i class="fa fa-times"></i></span>
    </ng-template>
  </p-column>

  <p-column header="Enabled" [style]="{'text-align':'center'}">
    <ng-template pTemplate="body" let-item="rowData">
      <p-inputSwitch [(ngModel)]="item.enabled" (onChange)="enabledSwitchChanged($event, item)"></p-inputSwitch>
    </ng-template>
  </p-column>

  <p-column header="Action" [style]="{'text-align':'center','width':'150px'}">
    <ng-template pTemplate="body" let-item="rowData">
      <button pButton (click)="selectedSetting=item; editSetting()" icon="fa ui-icon-mode-edit" label="Edit"></button>
    </ng-template>
  </p-column>

</p-dataTable>

-->

<p-dialog
  header="AutoDirect Setting"
  [(visible)]="displayDialog"
  [responsive]="true"
  [modal]="true"
  [positionTop]="10"
  [style]="{ width: '1000px' }"
>
  <div>
    <form [formGroup]="formGroup">
      <table class="mt-1">
        <tr>
          <td class="label-col">Setting Name:</td>
          <td>
            <input pInputText formControlName="settingName" id="settingName" />
          </td>
          <td class="label-col">Enabled:</td>
          <td>
            <p-inputSwitch formControlName="enabled"></p-inputSwitch>
          </td>
        </tr>

        <tr>
          <td class="label-col">
            <label for="taskTypes">Job Task Types:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Apply this setting to jobs with this task type"
            ></i>
          </td>
          <td>
            <p-multiSelect
              name="jobTaskTypesInput"
              [options]="jobTaskTypeList"
              formControlName="jobTaskTypesInput"
              id="taskTypes"
              defaultLabel="Task Types"
              styleClass="taskTypes"
            ></p-multiSelect>
          </td>

          <td class="label-col">
            Add to Directed:
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Add this Job to a suppliers 'Directed to you' inbox"
            ></i>
          </td>
          <td>
            <p-inputSwitch formControlName="addToDirected"></p-inputSwitch>
            &nbsp;
            <label for="maxDirected">Maximum: </label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Maximum number of Suppliers to Direct to"
            ></i>
            &nbsp;
            <input
              pInputText
              class="maxInputVal"
              type="number"
              formControlName="maxDirected"
              id="maxDirected"
              size="4"
            />
          </td>
        </tr>

        <tr>
          <td class="label-col">
            <label for="sequence">Sequence:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="The order the AutoDirects will be executed for a given Job, lowest first"
            ></i>
          </td>
          <td>
            <input pInputText formControlName="sequence" id="sequence" type="number" />
          </td>
          <td class="label-col">
            Send Alerts:
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Trigger a template event to deliver alerts by text/email"
            ></i>
          </td>
          <td>
            <p-inputSwitch formControlName="sendAlerts"></p-inputSwitch>
            &nbsp;
            <label for="maxAlerts">Maximum: </label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Maximum number of Alerts to deliver for the Job"
            ></i>
            &nbsp;
            <input
              pInputText
              type="number"
              class="maxInputVal"
              formControlName="maxAlerts"
              id="maxAlerts"
              size="4"
            />
          </td>
        </tr>

        <tr>
          <td class="label-col">
            <label for="hoursUntilNextSequence">Next Sequence in:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Duration (in hours) to wait until the next AutoDirect sequence is run"
            ></i>
          </td>
          <td>
            <input
              pInputText
              formControlName="hoursUntilNextSequence"
              id="hoursUntilNextSequence"
            />
            hours
          </td>
        </tr>

        <tr>
          <td colspan="4">
            <hr />
          </td>
        </tr>

        <tr>
          <td>&nbsp;</td>
          <td><strong>Match To Suppliers:</strong></td>
        </tr>

        <tr>
          <td class="label-col">
            <label for="maxAlerts">Supplier Classifications:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Which type of supplier to alert"
            ></i>
          </td>
          <td colspan="3">
            <p-multiSelect
              name="classification"
              [options]="supplierClassifications"
              formControlName="supplierClassificationsInput"
              defaultLabel="Classification"
              styleClass="filterItem"
            ></p-multiSelect>
          </td>
        </tr>

        <tr>
          <td class="label-col">
            <label for="maxAlerts">Supplier Contract Type:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Which supplier contract type to alert"
            ></i>
          </td>
          <td colspan="3">
            <p-multiSelect
              name="contractType"
              [options]="supplierContractTypes"
              formControlName="supplierContractTypesInput"
              defaultLabel="Contract Type"
              styleClass="filterItem"
            ></p-multiSelect>
          </td>
        </tr>

        <tr>
          <td class="label-col">
            <label for="maxDistanceToPickup">Max Distance To Pickup:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Only notify Suppliers that will be within maximum distance to pickup (either home location or their previous/next job)"
            ></i>
          </td>
          <td colspan="3">
            <input
              pInputText
              type="number"
              formControlName="maxDistanceToPickup"
              id="maxDistanceToPickup"
            />
            miles
          </td>
        </tr>

        <tr>
          <td class="label-col">
            <label for="maxDistanceToDropoff">Max Distance To Dropoff:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Only notify Suppliers that will be within maximum distance to dropoff (either home location or their previous/next job)"
            ></i>
          </td>
          <td colspan="3">
            <input
              pInputText
              type="number"
              formControlName="maxDistanceToDropoff"
              id="maxDistanceToDropoff"
            />
            miles
          </td>
        </tr>

        <!--
        <tr>
          <td class="label-col">
            <label for="maxDistanceToHome">Max Distance To Home/Base Address:</label>
            <i class="fa fa-question-circle"
               tooltipStyleClass='xtooltip'
               pTooltip="Only notify Suppliers where the Pickup/Dropoff will be within maximum distance of their home"
            ></i>
          </td>
          <td colspan="3">
            <input pInputText type=number formControlName="maxDistanceToHome" id="maxDistanceToHome">
            miles
          </td>
        </tr>
        -->

        <tr>
          <td class="label-col">
            <label for="jobTotalDistanceMin">Jobs With Total Distance Min:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Notify Suppliers will have a minimum distance to travel when this job is combined with an exiting job"
            ></i>
          </td>
          <td colspan="3">
            <input
              pInputText
              type="number"
              formControlName="jobTotalDistanceMin"
              id="jobTotalDistanceMin"
            />
            miles
          </td>
        </tr>

        <tr>
          <td class="label-col">
            <label for="jobTotalDistanceMax">Jobs With Total Distance Max:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Notify Suppliers will have a maximum distance to travel when this job is combined with an exiting job"
            ></i>
          </td>
          <td colspan="3">
            <input
              pInputText
              type="number"
              formControlName="jobTotalDistanceMax"
              id="jobTotalDistanceMax"
            />
            miles
          </td>
        </tr>

        <tr>
          <td class="label-col">
            <label for="returnJourneyPercentage">Return Journey Percentage:</label>
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Percentage of distance towards home from a previous job that this would be considered a return Job.  Eg. 25% trigger if this job brings them at least 25% the way to their home/start point"
            ></i>
          </td>
          <td colspan="3">
            <input
              pInputText
              type="number"
              formControlName="returnJourneyPercentage"
              id="returnJourneyPercentage"
            />
            miles
          </td>
        </tr>

        <tr>
          <td class="label-col">
            Prioritise Less Busy:
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Prioritises Suppliers are not Busy (see below)"
            ></i>
          </td>
          <td colspan="3">
            <p-inputSwitch formControlName="prioritiseLessBusy"></p-inputSwitch>
          </td>
        </tr>
        <tr>
          <td class="label-col">
            Considered "Busy" After:
            <i
              class="fa fa-question-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Suppliers are considered Busy if they already have this number of hours allocated for the day of the new Job"
            ></i>
          </td>
          <td colspan="3">
            <input pInputText type="number" formControlName="busyHours" id="busyHours" />
            hours on other jobs (during comparison period)
          </td>
        </tr>

        <tr>
          <td></td>
          <td colspan="3">
            <input type="hidden" formControlName="id" />
            <button
              type="button"
              pButton
              label="Cancel"
              class="ui-button-tertiary"
              (click)="displayDialog = false"
            ></button>
            <button
              type="button"
              [disabled]="formGroup.invalid || !formGroup.dirty"
              class="ui-button-primary"
              pButton
              icon="fa ui-icon-check"
              label="Save"
              (click)="Save()"
            ></button>
          </td>
        </tr>
      </table>
    </form>
  </div>
</p-dialog>
